import React from "react";
import { Box as MuiBox, BoxProps as MuiBoxProps } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledBox = styled(MuiBox)<MuiBoxProps>(({ theme }) => ({
  flexGrow: 1,
  maxWidth: "100%",
  paddingTop: theme.spacing(1.5),
  paddingBottom: theme.spacing(1.5),
  [theme.breakpoints.up("sm")]: {
    paddingTop: theme.spacing(2.5),
    paddingBottom: theme.spacing(2.5),
  },
}));

const Box = React.forwardRef<HTMLDivElement, MuiBoxProps>((props, ref) => {
  return <StyledBox ref={ref} {...props} />;
});

Box.displayName = "Box";

export default Box;
